<template>
  <div>
    <vue-tel-input
      :key="$i18n.locale"
      ref="telInput"
      v-model="phone"
      :valid-characters-only="true"
      :preferred-countries="preferredCountries"
      :default-country="defaultCountry"
      :input-options="inputOptions"
      :dropdown-options="dropdownOptions"
      :enabled-country-code="false"
      mode="international"
      @country-changed="onCountryChanged"
      @input="onInput"
    />
    <div v-if="errorMessage" class="error">
      {{ errorMessage }}
    </div>

    <div v-if="errorMessages">
      <span
        v-for="(error, i) in errorMessages"
        :key="i"
        class="external-error"
        >{{ error }}</span
      >
    </div>
  </div>
</template>

<script>
import i18n from "@/i18n";

export default {
  props: {
    value: String,
    errorMessages: Array,
  },
  data() {
    return {
      phone: "",
      currentCountry: { iso2: "IR", dialCode: "98" },
      errorMessage: "",
      preferredCountries: ["IR", "IQ", "US", "CA"],
      dropdownOptions: {
        showFlags: true,
        showDialCodeInList: false,
        showDialCodeInSelection: false,
        disabledDialCode: true,
      },
    };
  },

  computed: {
    inputOptions() {
      const isIran = this.currentCountry.iso2 === "IR";
      return {
        placeholder: isIran
          ? this.$t("login.phoneField.placeholderIran")
          : this.$t("login.phoneField.placeholderDefault"),
        maxlength: isIran ? 16 : 29,
        formatOnTyping: false,
      };
    },
    defaultCountry() {
      const locale = this.$i18n.locale;
      const countryMap = {
        fa: "IR",
        ar: "IQ",
        ar_ae: "AE",
        ar_iq: "IQ",
        en_US: "US",
        en_GB: "GB",
        de: "DE",
        fr: "FR",
        hy: "AM",
        ru: "RU",
        tr: "TR",
        zh_CN: "CN",
        zh_TW: "TW",
      };
      console.log(this.$i18n.locale, countryMap[locale], "locale-i18n");
      return countryMap[locale] || "IR";
    },
    maxDigits() {
      const code = this.currentCountry.iso2;
      const map = {
        IR: 12, // 989xxxxxxxxx
        IQ: 12, // 964xxxxxxxxx
        US: 11,
        CA: 11,
        GB: 11,
        AU: 11,
        AE: 10,
        SA: 10,
        EG: 11,
        DE: 12,
        FR: 11,
        RU: 11,
        TR: 11,
        CN: 13,
        TW: 10,
      };
      return map[code] || 15;
    },
  },
  watch: {
    "$i18n.locale": {
      handler(newLocale) {
        this.phone = "";
        this.$nextTick(() => {
          this.phone = `+${newLocale} `;

          this.$nextTick(() => {
            const input = this.$el.querySelector(".vti__input");
            if (input) input.focus();
          });
        });
        this.$forceUpdate();
      },
      immediate: true,
    },
  },
  methods: {
    getDialCode(iso2) {
      const codes = {
        IR: "98",
        IQ: "964",
        US: "1",
        CA: "1",
      };
      return codes[iso2.toUpperCase()] || "98";
    },
    onCountryChanged(country) {
      console.log(country, "country");
      this.phone = "";
      this.$nextTick(() => {
        this.currentCountry = country;
        this.phone = `+${country.dialCode} `;

        this.$nextTick(() => {
          const input = this.$el.querySelector(".vti__input");
          if (input) input.focus();
        });
      });
    },

    onInput(rawValue) {
      let cleanValue = (rawValue || "")
        .replace(/[^\d+]/g, "")
        .replace(/\++/g, "+")
        .replace(/^(\+)*/g, "+");
      const dialCode = this.currentCountry.dialCode;

      if (!cleanValue.startsWith(`+${dialCode}`)) {
        cleanValue = `+${dialCode}` + cleanValue.replace(/^\+\d*/, "");
      }

      const allDigits = cleanValue.replace(/\D/g, "");
      if (allDigits.length > this.maxDigits) {
        this.errorMessage = this.$t("login.phoneField.maxDigitsError", {
          count: this.maxDigits,
        });
        cleanValue = cleanValue.slice(
          0,
          cleanValue.length - (allDigits.length - this.maxDigits),
        );
      } else if (
        this.errorMessage &&
        this.errorMessage.includes(this.$t("login.phoneField.maxDigitsError"))
      ) {
        this.errorMessage = "";
      }

      if (this.currentCountry.iso2 === "IR") {
        const national = cleanValue.replace(/^\+98/, "");
        if (national && !national.startsWith("9")) {
          this.errorMessage = this.$t("login.phoneField.iranMustStartWith9");
          cleanValue = "+98";
          setTimeout(() => {
            if (
              this.errorMessage ===
              this.$t("login.phoneField.iranMustStartWith9")
            ) {
              this.errorMessage = "";
            }
          }, 4000);
        }
      }
      this.$emit("input", allDigits);
    },
  },
};
</script>

<style scoped>
.vue-tel-input {
  direction: ltr !important;
  border: 1px solid rgba(0, 0, 0, 0.6) !important;
  border-radius: 4px !important;
}

.error {
  color: #d32f2f;
  background-color: transparent !important;
  font-size: 13px;
  margin-top: 8px;
  direction: rtl;
  text-align: right;
  font-weight: 500;
}

.external-error {
  color: #d32f2f;
  background-color: transparent !important;
  font-size: 12px;
  display: block;
}
</style>
